/*
  The Spline globe uses the mouse wheel to zoom its scene and blocks the page scroll, so the
  page stopped while the pointer was over it. Stop the wheel event before it reaches the
  scene: the browser then scrolls the page. Drag and hover on the globe still work.
*/
document.querySelectorAll('.stores-main spline-viewer').forEach((viewer) => {
  viewer.addEventListener('wheel', (event) => event.stopPropagation(), { capture: true, passive: true });
});
